/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiRiskRule,
    ApiRiskRuleFromJSON,
    ApiRiskRuleToJSON,
    RiskRulePage,
    RiskRulePageFromJSON,
    RiskRulePageToJSON,
} from '../models';

export interface AddRiskRuleRequest {
    apiRiskRule: ApiRiskRule;
}

export interface FindAllRiskRulesRequest {
    page: number;
    size: number;
    query?: string;
}

/**
 * 
 */
export class RiskRuleApi extends runtime.BaseAPI {

    /**
     * Creates new risk rule
     */
    async addRiskRuleRaw(requestParameters: AddRiskRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiRiskRule>> {
        if (requestParameters.apiRiskRule === null || requestParameters.apiRiskRule === undefined) {
            throw new runtime.RequiredError('apiRiskRule','Required parameter requestParameters.apiRiskRule was null or undefined when calling addRiskRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/riskrules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiRiskRuleToJSON(requestParameters.apiRiskRule),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiRiskRuleFromJSON(jsonValue));
    }

    /**
     * Creates new risk rule
     */
    async addRiskRule(requestParameters: AddRiskRuleRequest, initOverrides?: RequestInit): Promise<ApiRiskRule> {
        const response = await this.addRiskRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all risk rules
     */
    async findAllRiskRulesRaw(requestParameters: FindAllRiskRulesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RiskRulePage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllRiskRules.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllRiskRules.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/riskrules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RiskRulePageFromJSON(jsonValue));
    }

    /**
     * Fetches all risk rules
     */
    async findAllRiskRules(requestParameters: FindAllRiskRulesRequest, initOverrides?: RequestInit): Promise<RiskRulePage> {
        const response = await this.findAllRiskRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
